//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { useForm } from "react-hook-form";

import MerchantInvoiceForm from "./MerchantInvoiceForm";

const EditMerchantInvoice = (props: any) => {
  const { handleEdit, isLoading } = props;
  const {
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>();
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Save"}
      isLoading={isLoading}
    >
      <MerchantInvoiceForm />
    </FormLayout>
  );
};

export default EditMerchantInvoice;
